import React from "react";
import { Box, Typography, IconButton, Divider } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import {
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import color from "../utils/Colors";

interface DataType {
  name: string;
  uv: number;
  avg: number;
}

interface StudentStatisticProps {
  data: DataType[];
  periodLabel: string;
  onPeriodChange: (direction: "previous" | "next") => void;
}

const StudentStatistic: React.FC<StudentStatisticProps> = ({
  data,
  periodLabel,
  onPeriodChange,
}) => {
  return (
    <Box
      sx={{
        backgroundColor: color.firstColor,
        color: "white",
        borderRadius: "10px",
        padding: "20px",
        width: "350px",
        height:'400px',
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h5" sx={{ fontWeight: "bold" }}>Student Statistic</Typography>
        <Box display="flex" alignItems="center">
          <IconButton
            size="small"
            sx={{ color: "white" }}
            onClick={() => onPeriodChange("previous")}
          >
            <ArrowBackIos fontSize="small" />
          </IconButton>
          <Typography variant="body2">{periodLabel}</Typography>
          <IconButton
            size="small"
            sx={{ color: "white" }}
            onClick={() => onPeriodChange("next")}
          >
            <ArrowForwardIos fontSize="small" />
          </IconButton>
        </Box>
      </Box>
      <Divider sx={{ borderColor: "white" }} />
      <Box display="flex" justifyContent="flex-end" mt={1.5} mb={1.5}>
        <Box display="flex" alignItems="center">
          <Box
            sx={{
              width: "10px",
              height: "10px",
              backgroundColor: "#018183",
              borderRadius: "50%",
              mr: 1,
            }}
          />
          <Typography variant="body2">Avg no.</Typography>
        </Box>
      </Box>

      <ResponsiveContainer
        width="100%"
        height={250}
        style={{ marginLeft: "-8px",padding:0 }}
      >
        <BarChart
          data={data}
          margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
          barSize={40}
        >
          <CartesianGrid stroke="white" vertical={false} horizontal={true} />
          <YAxis
            stroke="white"
            axisLine={false}
            tickLine={false}
            tick={{ fill: "white" }}
          />
          <XAxis
            dataKey="name"
            stroke="white"
            axisLine={false}
            tick={{ fill: "white" }}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: color.firstColor,
              border: "solid 1.5px white",
              borderRadius:'4px',
              color: "white",
            }}
          />
          <Bar dataKey="uv" fill="#d2abff" barSize={35} />
          <Line
            type="monotone"
            dataKey="avg"
            stroke="white"
            strokeWidth={2}
            dot={{ fill: "white", r: 6 }}
          />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default StudentStatistic;
